module.exports = __webpack_public_path__ + "img/collection.ae7c60cd.svg";